import React, { forwardRef } from "react";
import { Button, Link } from "react-ui";

import { FileProps } from "../Types";
import { Icon } from "../../../../../../Controls/Icons/Icon";

import { UploadFile } from "./UploadFile";
import { AddFiles } from "./UploadFile.styles";

export type ButtonType = "link" | "button";

interface UploadFilesContainerProps {
    files: FileProps[];
    removeFileHandler: (fileToRemove: FileProps) => void;
    setNewFileProps: (nextFileProps: FileProps) => void;
    pathToTable: string;
    addUserFilesToDrive: (multiple: boolean) => Promise<void>;
    multiple: boolean;
    buttonType?: ButtonType;
    getPortalUserId?: () => Promise<string>;
    useExternDriveClient?: boolean;
}

export const UploadFilesContainer = forwardRef(function UploadFilesContainer(
    {
        files,
        removeFileHandler,
        setNewFileProps,
        pathToTable,
        addUserFilesToDrive,
        multiple,
        buttonType = "link",
        getPortalUserId,
        useExternDriveClient,
    }: UploadFilesContainerProps,
    ref: React.ForwardedRef<HTMLElement>
) {
    const buttonProps = {
        ["data-tid"]: "AddFiles",
        icon: <Icon name="NetUploadIcon" />,
        onClick: () => addUserFilesToDrive(multiple),
        children: <span ref={ref}>Добавить файл{multiple ? "ы" : ""}</span>,
    };

    const buttonEl = buttonType === "button" ? <Button {...buttonProps} /> : <Link {...buttonProps} />;

    const addButtonFiles = (
        <AddFiles hidden={multiple === false && files.length === 1} isButton={buttonType === "button"}>
            {buttonEl}
        </AddFiles>
    );

    return (
        <>
            {files.map(file => (
                <UploadFile
                    key={file.id}
                    file={file}
                    removeFile={removeFileHandler}
                    setNewFileProps={setNewFileProps}
                    pathToTable={pathToTable}
                    getPortalUserId={getPortalUserId}
                    useExternDriveClient={useExternDriveClient}
                />
            ))}
            {addButtonFiles}
        </>
    );
});
